import FormField from './field.js';
import CurrencyFormatter from '../../utils/currency-formatter-lib';

export default class SavedCar extends FormField {

    constructor(parent, el) {
        super(parent, el);
        this.container = el.querySelector('.car-container');

        this.configuratorLongUrl = this.input('configuratorLongUrl');
        this.wishlistId = this.input('wishlistId');
        this.shareCode = this.input('shareCode');

        this.savedCars = this.parse();        
        this.location = el.dataset.location;
        this.param = el.dataset.param;
        this.template = _.template(el.querySelector('#configured-car').innerHTML.replaceAll('\\', ''));
        this.currency = window.HONDA.currency;
        this.utils = {
            formatPrice: new CurrencyFormatter().to,
            formatFinance: new CurrencyFormatter({ roundToDecimalPlace: +this.currency.roundToDecimalPlaceFinance || 0 }).to,
            formatAPR: (apr) => (apr ?? 0).toFixed(+this.currency.roundToDecimalPlaceFinanceAPR),
            pipeToSpace: (str) => str.replaceAll('|', ' '),
            capitalize: (str) => str && str[0].toUpperCase() + str.slice(1),
        };
        this.bind();
        this.populate();
    }

    parse() {
        const json = localStorage.getItem('save-for-later') || '[]';
        try {
            return JSON.parse(json);
        } catch {
            return [];
        }
    }

    bind() {
        if(this.location === 'hash') {
            window.addEventListener('hashchange', () => this.populate());
        }

        this.form.addEventListener('onResult', (result, body)  => {
            const id = this.get();
            const car = this.savedCars.find((c) => c.id === id);

            if(car) {
                car.dealer = body.get('dealer');
                car.dealerName = body.get('dealer_name');
                car.sharedOnDate = new Date().toISOString();
                car.shareWithDealer = true;
            }

            localStorage.setItem('save-for-later', JSON.stringify(this.savedCars));
        });
    }

    get(){
        if(this.location === 'hash') {
            return new URLSearchParams(window.location.hash.split("?")[1] || "").get(this.param);
        } else if(this.location === 'query') {
            return new URLSearchParams(window.location.search || "").get(this.param);
        }
    }

    populate(){
        const id = this.get();
        const car = this.savedCars.find((c) => c.id === id);
        if(car) {
            this.container.innerHTML = this.template({ data: car, utils: this.utils });
            this.configuratorLongUrl.el.value = car.carLongUrl ?? '';
            this.wishlistId.el.value = car.wishlistId ?? '';
            this.shareCode.el.value = car.shareCode ?? '';
            this.show();
        }
    }

    show() {
        this.el.classList.remove('hide');
    }

    hide() {
        this.el.classList.add('hide');
    }

    static is(el) {
        return super.is(el) && el.classList.contains('form_field_saved_car');
    }
}
